'use strict';

import controller from './footer.controller';
import './footer.css';

const FooterComponent = {
    template: `
        <footer class="footer text-info">
            <div class="footer-left">{{ $ctrl.version }}</div>
            <div class="footer-right">Agetic {{ $ctrl.year }}</div>
        </footer>
    `,
    controller
};

export default FooterComponent;


// WEBPACK FOOTER //
// ./src/app/common/layout/footer/footer.component.js